import { SidePhotoContentCardDataProps } from '@ahc-digital/component-library';
import { C13SidePhotoContentCardProps } from './C13SidePhotoContentCard.types';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';

export function GetSidePhotoContentCardModel({
  props,
}: {
  props?: C13SidePhotoContentCardProps;
  isEditing: boolean;
}): SidePhotoContentCardDataProps {
  const { renderRichText, renderLink, renderImage, renderText } = useConditionalRendering();
  const { fields, params } = props || {};

  const model: SidePhotoContentCardDataProps = {
    image: renderImage(fields?.Image, { required: true }),
    imageSide: getDroplink(params?.ImageSide, 'left'),
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    supportCopy: renderRichText(fields?.SupportCopy),
    primaryCtaButton: renderLink(fields?.PrimaryCtaButton),
    secondaryCtaButton: renderLink(fields?.SecondaryCtaButton),
    secondaryCtaStyle: getDroplink(params?.SecondaryCtaStyle, 'solid1'),
    primaryLink: renderLink(fields?.PrimaryLink),
    secondaryLink: renderLink(fields?.SecondaryLink),
    layout: getDroplink(params?.SecondaryCtaStyle, 'fifty'),
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };

  return model;
}
